<template>
    <BRow>
        <BCol>
            <div class="demo-inline-spacing text-center">
                <div>{{ $t('Component(ReceivedRequestConcernElements):is-complex-product') }}</div>
                <BFormRadio
                    name="workflow-is-complex-product"
                    :checked="value"
                    :value="true"
                    :disabled="includedSubstanceCount > 0"
                    @change="$emit('change', $event)"
                >
                    {{ $t('Component(Choice):yes') }}
                </BFormRadio>
                <BFormRadio
                    name="workflow-is-complex-product"
                    :checked="value"
                    :value="false"
                    :disabled="!canSwitchToSimple"
                    @change="$emit('change', $event)"
                >
                    {{ $t('Component(Choice):no') }}
                </BFormRadio>
                <InstructionInfoButton
                    class="pl-1"
                    :instruction="$t('Page(ReceivedRequest):Component(IButton):received-request-is-complex-instruction')"
                />
            </div>
        </BCol>
    </BRow>
</template>

<script>
import { BCol, BFormRadio, BRow } from 'bootstrap-vue'
import InstructionInfoButton from '@core/components/common/instructions/InstructionInfoButton.vue'

export default {
    name: 'WorkflowProductComplexitySection',
    components: {
        BCol,
        BFormRadio,
        BRow,
        InstructionInfoButton,
    },
    props: {
        value: { type: Boolean, default: null },
        includedSubstanceCount: { type: Number, default: 0 },
        canSwitchToSimple: { type: Boolean, default: true },
    },
}
</script>
